<template>
  <div class="main-container">
    <!-- 背景图片 -->
    <div class="background-layer">
      <img :src="back_img" alt="背景图" class="bg-image">
    </div>

    <!-- 内容容器 -->
    <div class="content-layer">
      <transition name="el-zoom-in-left" v-show="show">
        <div v-if="show" class="responsive-content">
          <!-- 图片卡片 -->
          <div class="image-card">
            <div class="image-wrapper">

              <div class="text-overlay">


                <el-divider class="fenge" style="border-color: #ecd452;margin-top: 20px">漳县政协“码上见”委员履职平台</el-divider>


                <img :src="back_img3" alt="徽标" class="main-image-hui">
                <div class="text-section primary-text">
                  <p>群众有话“码”上说</p>
                  <p>委员履职“码”上办</p>
                </div>


                <div class="text-section secondary-text">
                  <p>{{ work_station_name }}</p>
                  <p>欢迎线上建言</p>
                </div>

                <el-divider class="fenge" style="border-color: #ecd452;position: absolute;bottom: 5px">漳县政协“码上见”委员履职平台
                </el-divider>
              </div>
            </div>
          </div>

          <!-- 操作按钮 -->
          <div class="button-container">
            <button class="action-btn" @click="nav_to_user">我要建言</button>
          </div>
        </div>
      </transition>

      <transition name="el-zoom-in-left" v-show="show2">
        <div v-if="show2" class="responsive-content2">

          <div class="data-title"><span style="color: cornflowerblue">**</span>选择您要建言的委员</div>
          <div class="tab2-data">
            <div class="tab2-data-item" v-for="item in data_list" @click="choose_user(item)"
                 :class="{active_ccc:active_index === item.id}">
              <div class="tab2-data-item-img">
                <img :src="item.img" alt="">
              </div>
              <div class="tab2-data-item-name">
                {{ item.name }}：{{ item.zhiwu }}（{{ item.phone }}）
              </div>
            </div>
          </div>


          <!-- 操作按钮 -->
          <div class="button-container2">
            <button class="action-btn2" @click="nav_to_index">上一步</button>
            <button class="action-btn2" @click="nav_to_liuyan">我要建言</button>
          </div>
        </div>
      </transition>


      <!--      <el-collapse-transition v-show="show3">-->
      <!--        <div style="background-color: #e67e22;width: 200px;height: 100px" v-show="show3"></div>-->

      <!--      </el-collapse-transition>-->


      <transition name="el-zoom-in-left" v-show="show3">
        <div v-if="show3" class="responsive-content3">
          <div class="tab3-h1">{{ work_station_name }}</div>
          <div class="tab3-title">
            <span style="color: red">**</span>建言内容
          </div>
          <div class="tab3-input">
            <!--            <input type="text" placeholder="请输入" class="tab3-input-input">-->
            <textarea class="tab3-input-input" cols="20" rows="10" v-model="apply_text"></textarea>
          </div>
          <div class="tab3-title">
            <span style="color: red">**</span>姓名
          </div>
          <div class="tab3-input">
            <input type="text" placeholder="请输入" class="tab3-input-input" v-model="apply_name">
          </div>
          <div class="tab3-title">
            <span style="color: red">**</span>联系电话
          </div>
          <div class="tab3-input">
            <input type="text" placeholder="请输入" class="tab3-input-input" v-model="apply_phone">
          </div>
          <div class="tab3-title">
            <span style="color: red"></span>邮箱地址
          </div>
          <div class="tab3-input">
            <input type="text" placeholder="请输入" class="tab3-input-input" v-model="apply_email">
          </div>
          <div class="tab3-title">
            <span style="color: red"></span>建言日期
          </div>
          <div class="tab3-input">


            <el-date-picker

                v-model="time3"
                type="date"
                size="large"
                placeholder="请选择"
                format='YYYY-MM-DD'
                value-format='YYYY-MM-DD'
            />


          </div>


          <!-- 操作按钮 -->
          <div class="button-container3">
            <button class="action-btn2" @click="nav_to_user2">上一步</button>
            <button class="action-btn2" @click="nav_submit">提交</button>
          </div>
        </div>
      </transition>

      <transition name="el-zoom-in-left" v-show="show4">
        <div v-if="show4" class="responsive-content4">

          <el-icon size="100px" color="#FFFFFF">
            <Select/>
          </el-icon>

          <div class="ti_suc">提交成功</div>

        </div>
      </transition>


    </div>
  </div>
</template>
<script setup>


import $axios from "axios";
import {base_url} from "@/common/js/settings";
import {ref, onBeforeMount, onMounted} from 'vue'
import {ElMessage, ElMessageBox} from "element-plus";

import {useRouter} from 'vue-router'

const router = useRouter()
const back_img = ref('')
const back_img2 = ref('')
const back_img3 = ref('http://cdn.liubeixi.holink.cc/wangye/hui.png')
const work_station_name = ref('')
const show = ref(false)
const show2 = ref(false)
const show3 = ref(false)
const show4 = ref(false)
const active_index = ref(-1)

const data_list = ref([])
const time3 = ref('')

const apply_text = ref('')
const apply_name = ref('')
const apply_phone = ref('')
const apply_email = ref('')


onMounted(() => {
  get_back_img_func()
  // console.log('uuid:',router.currentRoute.value.query.uuid)


  if (router.currentRoute.value.query.uuid) {
    get_data_func(router.currentRoute.value.query.uuid)
  }
  setTimeout(() => {
    show.value = true
  }, 1500)


})


//提交
const nav_submit = () => {

  if (!apply_text.value || !apply_name.value || !apply_phone.value) {
    return ElMessage.error('请补全信息')
  } else {

    $axios({
      url: base_url + '/submit/',
      method: 'post',
      data: {
        user_id: active_index.value,
        apply_text: apply_text.value,
        apply_name: apply_name.value,
        apply_phone: apply_phone.value,
        apply_email: apply_email.value,
        time3: time3.value,
      }

    }).then((res) => {
      console.log(res)


    })


    show3.value = false
    ElMessage.success('提交成功')
    setTimeout(() => {
      show4.value = true
    }, 800)
  }


}

//留言转委员
const nav_to_user2 = () => {
  show3.value = false

  setTimeout(() => {
    show2.value = true
  }, 800)
}


//点击委员
const choose_user = (item) => {
  active_index.value = item.id

  show2.value = false


  setTimeout(() => {
    show3.value = true
  }, 800)
  // show3.value = true

}


//选择委员
const nav_to_user = () => {
  show.value = false

  setTimeout(() => {
    show2.value = true
  }, 800)


}


const nav_to_liuyan = () => {
  console.log(1111111111111)


  if (active_index.value === -1) {
    return ElMessage.error('请选择委员')
  } else {
    show2.value = false
    show3.value = true
  }
}


//委员页面转首页
const nav_to_index = () => {
  show2.value = false
  setTimeout(() => {
    show.value = true
  }, 800)
}


//获取数据
const get_data_func = (uuid) => {
  $axios({
    url: base_url + '/get_data?uuid=' + uuid,
    method: 'get',

  }).then((res) => {
    console.log(res)
    document.title = res.data.data.name
    work_station_name.value = res.data.data.name
    data_list.value = res.data.data.users


  })
}


//获取背景图
const get_back_img_func = () => {
  $axios({
    url: base_url + '/get_back/',
    method: 'get',

  }).then((res) => {
    // console.log(res)
    // back_img.value = res.data[0].back_img
    // back_img2.value = res.data[0].back_img2
    back_img.value = 'https://cdn.liubeixi.holink.cc/wangye/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250414095510.jpg'
    back_img2.value = 'https://cdn.liubeixi.holink.cc/wangye/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250409000443.png'

  })
}


</script>

<style scoped lang="scss">
/* 响应式设计变量 */
$mobile-breakpoint: 576px;
$tablet-breakpoint: 992px;
$primary-color: #c62828;
$secondary-color: #ef6c00;

.main-container {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
}

.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  .bg-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.85);
  }
}

.content-layer {
  position: relative;
  z-index: 2;
  width: 100%;
  margin-top: 20px;
  min-height: 70vh;
  //padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  //background-color: #42b983;
}

.responsive-content {
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  height: 100%;

  //align-items: center;
}

.responsive-content2 {
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 15px;

  //align-items: center;
}


.responsive-content3 {
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 15px;

  //align-items: center;
}


.responsive-content4 {
  display: flex;
  flex-direction: column;
  .ti_suc{
    width: 100%;
    text-align: center;
    font-size: 1.4rem;
    color: white;
    font-family: '华文楷体', cursive;
  }

}


.image-card {
  width: 85%;
  height: 70vh;
  //margin: 0 auto;
  margin-left: auto;
  margin-right: auto;


  position: relative;

  //border-radius: 16px;
  overflow: hidden;


  .image-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #801414;

    //.main-image {
    //  width: 100%;
    //  height: 100%;
    //  position: absolute;
    //  z-index: 4;
    //  //object-fit: cover;
    //}

    //.main-image-hui{
    //  width: 70%;
    //  aspect-ratio: 0.8;
    //  margin-left: 15%;
    //  //background-color: #e67e22;
    //
    //
    //  //object-fit: cover;
    //  position: absolute;
    //  z-index:5
    //}
  }
}

.text-overlay {
  position: absolute;
  //top: 0;
  //left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  color: #ecd452;

  z-index: 5;

  .fenge ::v-deep .el-divider__text {
    color: #ecd452;
    text-align: center;
    background-color: #801414;

    font-family: '华文楷体', cursive;
    white-space: nowrap;

  }


  .main-image-hui {
    width: 30%;
    aspect-ratio: 1;
    margin-left: 35%;
  }


  .text-section {
    text-align: center;
    width: 100%;
    font-family: '华文楷体', cursive;


    &.primary-text {
      margin-bottom: 12%;

      p {
        //color: $primary-color;

        font-size: clamp(2.2rem, 4vw, 2.4rem);

        line-height: 1.3;
        font-weight: 700;
        text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.3);

      }
    }

    &.secondary-text {
      margin-bottom: 50px;

      p {

        font-size: clamp(1.8rem, 3vw, 2rem);
        line-height: 1.4;
        font-weight: 600;

      }
    }
  }
}

.button-container {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
}

.button-container2 {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 50px;
}

.button-container3 {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 50px;
}

.action-btn {
  width: 80%;

  margin-top: 30px;
  max-width: 280px;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, $primary-color, $secondary-color);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: clamp(1.5rem, 3vw, 1.8rem);
  font-family: '华文楷体', cursive;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba($primary-color, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba($primary-color, 0.4);
  }

  &:active {
    transform: translateY(1px);
  }
}


.action-btn2 {
  width: 40%;

  margin-top: 30px;
  max-width: 200px;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, $primary-color, $secondary-color);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: clamp(1.2rem, 3vw, 1.8rem);
  font-family: '华文楷体', cursive;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba($primary-color, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba($primary-color, 0.4);
  }

  &:active {
    transform: translateY(1px);
  }
}


/* 响应式调整 */
@media (max-width: $tablet-breakpoint) {
  .content-layer {
    //padding: 1.5rem;
  }

  .image-card {
    width: 90%;
    //margin: 1.5rem 0;
  }

}

@media (max-width: $mobile-breakpoint) {
  .content-layer {
    //padding: 1rem;
  }

  .image-card {
    width: 95%;

    //border-radius: 12px;


  }

  .action-btn {
    width: 90%;

  }
  .action-btn2 {
    width: 60% !important;

  }
  .responsive-content2 {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: transparent;

  }
  .responsive-content3 {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: transparent;
    border-radius: 15px;

    //align-items: center;
  }


  .responsive-content4 {
    display: flex;
    flex-direction: column;
  }

  .data-title {
    color: white !important;
  }
  .tab2-data {
    width: 100%; // 改为全宽
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .tab2-data-item {
      width: 40% !important;
      //margin: 0 auto;
      //margin-left: 7%;
      //padding: 0 5px; // 增加左右间距
      margin-top: 10px;
      background-color: white;
      border-radius: 10px;

      .tab2-data-item-img {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        width: 100%; // 减少图片容器宽度
        margin-left: 0;
        aspect-ratio: 0.75;

        img {
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          width: 100%;
          height: 100%;
        }

      }


      .tab2-data-item-name {
        width: 90%;
        margin-left: 5%;
        text-align: center;
        margin-bottom: 10px;

      }
    }
  }

}

/* 过渡动画 */
.content-transition-enter-active {
  transition: all 0.8s ease-out;
}

.content-transition-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.tab2-data {
  margin-top: 50px;
  width: 90%;
  margin-left: 5%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;

  //background-color: #e67e22;


  .tab2-data-item {
    width: 22%;

    margin-top: 10px;

    .tab2-data-item-img {
      //width: 60%;
      //margin-left: 20%;
      //aspect-ratio: 3/4;
      //background-color: #e67e22;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .tab2-data-item-name {
      font-size: 0.8rem;
      width: 90%;
      margin-left: 5%;
      text-align: center;
    }

  }
}

.data-title {
  margin-top: 30px;
  margin-left: 20px;
  color: #000000;
  font-size: 1.5rem;


}

.tab3-h1 {
  text-align: center;
  margin-top: 10px;
  font-size: 1.5rem;
  font-weight: bold;
}

.tab3-title {
  margin-left: 20px;
  margin-top: 20px;
  font-size: 1.5rem;
  font-weight: bold;

}

.tab3-input {
  width: 80%;
  margin-top: 20px;
  margin-left: 20px;

  //background-color: #e67e22;
  .tab3-input-input {
    width: 100%;
    min-height: 50px;
    border-radius: 5px;
    border: none;
    background-color: #ecf0f1;
    text-indent: 2em;
  }
}

.active_ccc {
  background-color: #1e90ff !important;
}


</style>